<template>
<div class="modal fade" :id="elements.modalId" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ elements.title }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{ elements.content }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="confirmDelete">Save changes</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    props: ['elements'],
    methods: {
        confirmDelete() {
            this.$emit('confirm')
        }
    }
}
</script>